const MenuItemHeight = 49;

export default MenuItemHeight;
